import { __awaiter, __generator } from "tslib";
import { getHistory } from '../routing/history';
import { isAnalytics, isError, isFlight, isFramework, isPerformance, LogCategory, } from './log.types';
import { scrubMessage } from './loggingUtils';
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Info"] = 1] = "Info";
    LogLevel[LogLevel["Comment"] = 2] = "Comment";
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["Critical"] = 5] = "Critical";
})(LogLevel || (LogLevel = {}));
// This is the same id used in backend - /libs/SuiteShared/Server/Util/Logging/Log.cs
var UnifiedFlightTagID = 526460;
var loggingQueueLocked = true;
export function makeMacKustoLogger(appIdStr, kustoEndpointStr, hostNameStr, versionInfoStr) {
    var loggingQueueInterval = 1000;
    var queue = [];
    var xhrPromise = Promise.resolve();
    var remoteLoggerSequenceNumber = 0;
    var appId = appIdStr;
    var kustoEndpoint = kustoEndpointStr;
    var hostName = hostNameStr;
    var versionInfo = versionInfoStr;
    /**
     * Type confirms with server-side contract
     */
    var scheduleNextSend = function () {
        setTimeout(function () {
            sendInstrumentRequest().catch(function () {
                // do nothing as this is invoked from setTimeout needs to be safe
            });
        }, loggingQueueInterval);
    };
    /**
     * Http request used exclusively for talking with /api/instrument
     */
    var sendInstrumentRequest = function () {
        if (queue.length === 0 || loggingQueueLocked) {
            scheduleNextSend();
            return Promise.resolve();
        }
        // TODO: sendBeacon() is broken right now in Chrome:
        // http://crbug.com/490015
        xhrPromise = new Promise(function (resolve, reject) {
            var req = new XMLHttpRequest();
            req.open('POST', kustoEndpoint, true);
            req.setRequestHeader('Content-Type', 'application/json');
            // Set common headers
            req.setRequestHeader('x-ms-mac-hostingapp', hostName);
            req.setRequestHeader('x-ms-mac-appid', appId);
            req.setRequestHeader('x-ms-mac-version', versionInfo);
            req.onreadystatechange = function () {
                if (req.readyState === XMLHttpRequest.DONE) {
                    if (req.status !== 204) {
                        var err = new Error("Request to /api/instrument/logclient failed, server responseCode: " + req.status + " body: " + req.response);
                        console.log(err);
                        reject(err);
                        return;
                    }
                    resolve();
                }
            };
            var data = queue.splice(0, queue.length);
            req.send(JSON.stringify(data));
        });
        return xhrPromise.then(scheduleNextSend);
    };
    scheduleNextSend();
    var queueLog = function (data) {
        queue.push(data);
    };
    function flush() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.all([xhrPromise, sendInstrumentRequest()]).then(function () {
                        return;
                    })];
            });
        });
    }
    function macKustoLogger(options) {
        // only log anything that is not analytics, perf, or framework
        if (isAnalytics(options) || isPerformance(options) || isFramework(options)) {
            return;
        }
        remoteLoggerSequenceNumber += 1;
        var pathName = '', flyoutName = '';
        try {
            pathName = getHistory().location.pathname;
            if (pathName !== null && pathName.indexOf(':') !== -1) {
                var pathArray = pathName.split(':');
                pathName = pathArray[0];
                flyoutName = pathArray[1];
            }
        }
        catch (error) {
            pathName = '';
            flyoutName = '';
        }
        if (isFlight(options)) {
            // Flight log: AdHoc0=flightName, AdHoc1=flight data
            queueLog({
                TagId: UnifiedFlightTagID,
                LogLevel: LogLevel.Info,
                LogCategory: LogCategory.ClientAnalytics,
                Message: "UI Flight: " + options.flightName,
                Adhoc0: options.flightName,
                Adhoc1: JSON.stringify(options.flightData),
                Adhoc2: scrubMessage(JSON.stringify(options.data)),
                Adhoc3: remoteLoggerSequenceNumber.toString(),
                Adhoc5: scrubMessage(flyoutName),
                PageName: scrubMessage(pathName),
            });
        }
        else {
            var tagId = parseInt(options.id, 10);
            queueLog({
                TagId: tagId,
                LogLevel: LogLevel.Info,
                LogCategory: options.logCategory || LogCategory.ClientInfo,
                Message: scrubMessage(options.message || ''),
                Adhoc0: appId,
                Adhoc1: remoteLoggerSequenceNumber.toString(),
                Adhoc2: scrubMessage(JSON.stringify({
                    data: options.data,
                })),
                Adhoc5: scrubMessage(flyoutName),
                PageName: scrubMessage(pathName),
            });
            if (isError(options)) {
                var stack = options.error.stack || '';
                // log the stack under 500781
                queueLog({
                    TagId: 500781,
                    LogLevel: LogLevel.Error,
                    LogCategory: options.logCategory || LogCategory.ClientError,
                    Message: "UI Exception: " + (options.error.message || ''),
                    Adhoc0: appId,
                    Adhoc1: remoteLoggerSequenceNumber.toString(),
                    Adhoc2: scrubMessage(JSON.stringify({
                        version: versionInfo,
                        stack: stack,
                    })),
                    Adhoc3: tagId.toString(),
                    Adhoc5: scrubMessage(flyoutName),
                    PageName: scrubMessage(pathName),
                });
            }
        }
    }
    return { logger: macKustoLogger, flush: flush };
}
export function unlockLoggingQueue() {
    loggingQueueLocked = false;
}
